var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#2C79FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 27.9584H15.6667C12.625 27.9584 10.875 26.2084 10.875 23.1667V14.8334C10.875 11.7917 12.625 10.0417 15.6667 10.0417H22.3333C25.375 10.0417 27.125 11.7917 27.125 14.8334V23.1667C27.125 26.2084 25.375 27.9584 22.3333 27.9584ZM15.6667 11.2917C13.2833 11.2917 12.125 12.45 12.125 14.8334V23.1667C12.125 25.55 13.2833 26.7084 15.6667 26.7084H22.3333C24.7167 26.7084 25.875 25.55 25.875 23.1667V14.8334C25.875 12.45 24.7167 11.2917 22.3333 11.2917H15.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4166 16.7083H22.7499C21.4833 16.7083 20.4583 15.6833 20.4583 14.4167V12.75C20.4583 12.4083 20.7416 12.125 21.0833 12.125C21.4249 12.125 21.7083 12.4083 21.7083 12.75V14.4167C21.7083 14.9917 22.1749 15.4583 22.7499 15.4583H24.4166C24.7583 15.4583 25.0416 15.7417 25.0416 16.0833C25.0416 16.425 24.7583 16.7083 24.4166 16.7083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 20.4583H15.6667C15.3251 20.4583 15.0417 20.175 15.0417 19.8333C15.0417 19.4916 15.3251 19.2083 15.6667 19.2083H19.0001C19.3417 19.2083 19.6251 19.4916 19.6251 19.8333C19.6251 20.175 19.3417 20.4583 19.0001 20.4583Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3334 23.7917H15.6667C15.3251 23.7917 15.0417 23.5084 15.0417 23.1667C15.0417 22.825 15.3251 22.5417 15.6667 22.5417H22.3334C22.6751 22.5417 22.9584 22.825 22.9584 23.1667C22.9584 23.5084 22.6751 23.7917 22.3334 23.7917Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamIcon);
export default __webpack_public_path__ + "static/media/examIcon.a91914785a86a101b409c53411a1ea9d.svg";
export { ForwardRef as ReactComponent };